module.exports = __webpack_public_path__ + "static/media/caution@2x.e0f32b03.png";